import React, { useState, useRef } from "react";

export default function TrackItem({
  index,
  img,
  duration,
  width,
  onDurationChange,
  onDragStart,
}) {
  const [resizing, setResizing] = useState(false);
  const startX = useRef(0);
  const startDuration = useRef(duration);

  /* ───── Resize logic ───── */
  const onResizeDown = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setResizing(true);
    startX.current = e.clientX;
    startDuration.current = duration;
  };

  const onMouseMove = (e) => {
    if (!resizing) return;

    const diff = e.clientX - startX.current;
    const pxPerSec = width / duration;
    const deltaSeconds = diff / pxPerSec;

    onDurationChange(
      index,
      Math.max(0.5, startDuration.current + deltaSeconds)
    );
  };

const onMouseUp = () => {
  if (resizing) setResizing(false);
};


  /* ───── Reorder drag start ───── */
  const handleMouseDown = (e) => {
    if (resizing) return;          // ❗ DO NOT start drag while resizing
    e.preventDefault();
    onDragStart?.();
  };

  return (
    <div
      onMouseDown={handleMouseDown}
      onMouseMove={onMouseMove}
      onMouseUp={onMouseUp}
      className="
        relative flex-shrink-0 overflow-hidden rounded
        bg-gray-200 dark:bg-gray-800
        border border-gray-300 dark:border-gray-700
        cursor-grab active:cursor-grabbing
        select-none
      "
      style={{ width, height: "60px" }}
    >
      {/* Thumbnail */}
      <img
        src={img.url || img.src}
        draggable={false}
        className="h-full w-full object-cover opacity-80 pointer-events-none"
      />

      {/* Resize handle */}
      <div
        onMouseDown={onResizeDown}
        className="
          absolute right-0 top-0 h-full w-2
          cursor-ew-resize
          bg-blue-500 hover:bg-blue-600
        "
      />

      {/* Duration */}
      <div className="absolute bottom-0 left-0 right-0 bg-black/60 text-white text-[10px] text-center">
        {duration.toFixed(2)}s
      </div>
    </div>
  );
}
